import { environment } from './../../../environments/environment';


export class SessionDataController {
  // class definition
  constructor(public idb: any) {}


  /**
   * @returns {Promise}
   */
  public async sessionIsOnline(): Promise<any> {
    return await this.idb.sessionData.get(1);
  }

  public updateOnlineStatusOnOfflineDB(isOnline: boolean): void {
    this.idb
      .transaction('rw', this.idb.sessionData, async () => {
        if ((await this.idb.sessionData.where({ id: 1 }).count()) === 0) {
          const id = await this.idb.sessionData.add({
            isStillOnline: isOnline,
            baseApiUrl: environment.apiUrl,
          });
          console.log(
            `isStillOnline como no existía se agrego con valor ${isOnline}`
          );
        } else if (
          (await this.idb.sessionData.where({ id: 1 }).count()) === 1
        ) {
          await this.idb.sessionData
            .update(1, { isStillOnline: isOnline })
            .then((updated) => {
              if (updated) {
                console.warn(`isStillOnline was updated to ${isOnline}`);
              } else {
                console.error('no se actualizo nada');
              }
            });
        }
      })
      .catch((e) => {
        console.error(`ERROR durante la Transaction isStillOnline`);
        console.log(e.stack || e);
      });
  }

  public updateLastUpdateOnOfflineDB(lastUpdate: number): void {
    // this.idb.transaction('rw', this.idb.sessionData, async () => {
    //   if ((await this.idb.sessionData.where({ id: 1 }).count()) === 0) {
    //     const id = await this.idb.sessionData.add({ isStillOnline: isOnline });
    //     console.log(`isStillOnline como no existía se agrego con valor ${isOnline}`);
    //   }
    //   else if ((await this.idb.sessionData.where({ id: 1 }).count()) === 1) {
    //     await this.idb.sessionData.update(1, { isStillOnline: isOnline })
    //       .then(function (updated) {
    //         if (updated) {
    //           console.log('se actualizo');
    //           console.log(`isStillOnline was updated to ${isOnline}`);
    //         } else {
    //           console.log('no se actualizo nada');
    //         }
    //       });
    //   }
    // }).catch(e => {
    //   console.log(e.stack || e);
    //   console.log(e.stack || e);
    // });
  }
}
